import { render } from "./InputPercentage.vue?vue&type=template&id=8e16c4ca"
import script from "./InputPercentage.vue?vue&type=script&lang=js"
export * from "./InputPercentage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__